<template>
  <CSidebar
    aside
    :show="$store.state.selectNewImageAsideShow"
    @update:show="(val) => $store.commit('set', ['selectNewImageAsideShow', val])"
    colorScheme="light"
    overlaid
    size="lg"
  >
    <CSidebarClose @click.native="$store.commit('toggle', 'selectNewImageAsideShow')" />

    <CListGroup class="scrollable list-group-accent mt-5">
      <CListGroupItem class="mb-0 list-group-item-accent-primary bg-light text-center font-weight-bold text-uppercase">
        SELECT NEW IMAGE
      </CListGroupItem>

      <CListGroupItem class="list-group-item-accent-secondary">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <strong>Filter</strong>
        <CButton color="primary" size="sm" @click="addNewImage" class="vertical-center">
          <CIcon name="cil-plus" /> Add New
        </CButton>
      </div>
        <!-- Tag Filter -->
        <v-select
          class="v-select-filter"
          placeholder="Tags.."
          v-model="tags"
          :options="tagList"
          :reduce="t => t.id"
          label="name"
          multiple
          :searchable="true"
          @input="getAllItems"
        />

        <div class="image-container">
          <ul class="image-list">
            <li v-for="image in loadedItems" :key="image.id" @click="selectedImage = image" :class="{ 'selected': image === selectedImage || (!selectedImage && image.id == imageId)}">
              <img :src="image.image_url" />
            </li>
          </ul>
        </div>
      </CListGroupItem>

      <CListGroupItem class="sticky-bottom list-group-item-accent-primary bg-white">
        <CButton
          color="primary"
          :disabled="!selectedImage"
          @click="select"
        >
          Select
        </CButton>
      </CListGroupItem>
    </CListGroup>

    <CElementCover :opacity="0.4" v-show="loading"/>

    <!-- New Image Modal -->
    <NewImage
      :typeList="typeList"
      :tagList="tagList"
      :response.sync="response"
      @typeChanged="getTags"
    />
  </CSidebar>
</template>

<script>
import { mapGetters } from "vuex";
import NewImage from "@/components/Images/NewImage.vue";

export default {
  name: "SelectImage",
  components: { NewImage },
  props: {
    imageId: { type: [Number], default: null },
    type: { type: [String], default: 'category' }
  },
  data() {
    return {
      loading: false,
      selectedImage: null,

      loadedItems: [],
      tagList: [],
      tags: [],
      response: {},
    };
  },

  watch: {
    async reloadParams() {
      this.loading = true;
      if (this.$store.state.selectNewImageAsideShow) {
        this.selectedImage = null;
        await Promise.all([
          !this.tagList.length && this.getTags(),
          !this.loadedItems.length && this.getAllItems()
        ].filter(Boolean));
      }
      this.loading = false;
    },
    'response.status': {
      async handler(val) {
        if (val === 'success') {
          // Tag merging
          this.response.image.tags.forEach(iTag => {
            if (!this.tagList.some((tag) => tag.id === iTag.id)) {
              this.tagList.push(iTag);
            }
          });

          // Listeyi tazele ve eklenen görseli otomatik seç
          await this.getAllItems();
          const createdId = this.response.image.id;
          const found = this.loadedItems.find((i) => i.id === createdId);
          if (found) this.selectedImage = found;

          // Modal kapanınca state'i sıfırla
          this.response.status = false;
        }
      },
    },
  },

  computed: {
    ...mapGetters(["errors"]),

    reloadParams() {
      return [this.$store.state.selectNewImageAsideShow];
    },
    typeList() {
      return ['Category', 'Hero', 'Message'];
    }
  },

  methods: {
    addNewImage() {
      // Modal açılmadan önce mevcut tipi store filtresine ayarla
      const type = (this.type || '').toString();
      if (this.$store.state?.filters?.images) {
        this.$store.state.filters.images.type = this.$options.filters.ucfirst(type);
      }
      this.$store.commit('set', ['newImageAsideShow', true]);
    },
    async getTags(type) {
      await this.$axios
        .get(this.$backend.IMAGES.TAGS, {
          params: { type: type || this.type },
        })
        .then((response) => {
          this.tagList = response.data;
        });
    },

    async getAllItems() {
      var url = new URL(this.$backend.IMAGES.GET_ALL),
        params = {
          type: this.type,
          tags: this.tags,
        };

      Object.keys(params).forEach((key) => {
        if (
          typeof params[key] !== "undefined" &&
          params[key] !== null &&
          params[key] !== "" &&
          params[key].length !== 0
        )
          url.searchParams.append(key, params[key]);
      });

      await this.$axios.get(url)
        .then(({data}) => {
          this.loadedItems = data;
        });
    },

    select() {
      this.$emit('image-selected', this.selectedImage);
      this.$store.commit('set', ['selectNewImageAsideShow', false]);
    },
  }
};
</script>

<style scoped>
.scrollable {
  overflow-y: auto;
  height: 100%;
}

.image-container {
  margin-top: 20px;
}
.image-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.image-list li {
  margin: 5px 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.image-list li:hover {
  transform: scale(1.05);
}
.image-list li.selected {
  padding: 0.25rem;
  outline: 3px solid #3498db;
  border-radius: 5px;
}
.image-list img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}
</style>
